<template>
  <permission-guard situation="site_configuration">
    <v-form>
      <v-row>
        <v-col cols="8">
          <span class="text-h6"> Amazon Product Advertising API </span>
          <v-row>
            <v-col col="6">
              <v-text-field
                v-model="apiKey.amazonPaAccessKey"
                class="ml-2"
                label="access key"
                style="width: 350px"
              />
            </v-col>
            <v-col col="6">
              <v-text-field
                :value="beforeApiKeyData.maskedAmazonPaAccessKey || '未設定'"
                outlined
                disabled
                class="mb-2"
                label="access key"
                style="width: 350px"
              />
            </v-col>
            <v-col col="6">
              <v-text-field
                v-model="apiKey.amazonPaSecretKey"
                class="ml-2"
                label="secret key"
                style="width: 350px"
              />
            </v-col>
            <v-col col="6">
              <v-text-field
                :value="beforeApiKeyData.maskedAmazonPaSecretKey || '未設定'"
                outlined
                disabled
                class="mb-2"
                label="secret key"
                style="width: 350px"
              />
            </v-col>
            <v-col col="6">
              <v-text-field
                v-model="apiKey.amazonPaAssociateTag"
                class="ml-2"
                label="associate tag"
                style="width: 350px"
              />
            </v-col>
            <v-col col="6">
              <v-text-field
                :value="beforeApiKeyData.amazonPaAssociateTag || '未設定'"
                outlined
                disabled
                class="mb-2"
                label="associate tag"
                style="width: 350px"
              />
            </v-col>
          </v-row>
          <span class="text-h6"> 楽天 API </span>
          <v-row>
            <v-col col="6">
              <v-text-field
                v-model="apiKey.rakutenWsApplicationId"
                class="ml-2"
                label="application id"
                style="width: 350px"
              />
            </v-col>
            <v-col col="6">
              <v-text-field
                :value="
                  beforeApiKeyData.maskedRakutenWsApplicationId || '未設定'
                "
                outlined
                disabled
                class="mb-2"
                label="application id"
                style="width: 350px"
              />
            </v-col>
            <v-col col="6">
              <v-text-field
                v-model="apiKey.rakutenWsAffiliateId"
                class="ml-2"
                label="affiliate id"
                style="width: 350px"
              />
            </v-col>
            <v-col col="6">
              <v-text-field
                :value="beforeApiKeyData.rakutenWsAffiliateId || '未設定'"
                outlined
                disabled
                class="mb-2"
                label="affiliate id"
                style="width: 350px"
              />
            </v-col>
          </v-row>
          <span class="text-h6"> お名前.comメールマーケティング API </span>
          <v-row>
            <v-col col="6">
              <v-text-field
                v-model="apiKey.onamaeMmContractId"
                class="ml-2"
                label="contract id"
                style="width: 350px"
              />
            </v-col>
            <v-col col="6">
              <v-text-field
                :value="
                  beforeApiKeyData.maskedOnamaeMmContractId || '未設定'
                "
                outlined
                disabled
                class="mb-2"
                label="contract id"
                style="width: 350px"
              />
            </v-col>
            <v-col col="6">
              <v-text-field
                v-model="apiKey.onamaeMmPassword"
                class="ml-2"
                label="password"
                style="width: 350px"
              />
            </v-col>
            <v-col col="6">
              <v-text-field
                :value="
                  beforeApiKeyData.maskedOnamaeMmPassword || '未設定'
                "
                outlined
                disabled
                class="mb-2"
                label="password"
                style="width: 350px"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-form>
    <v-spacer />
    <v-btn color="green darken-1" tile dark depressed @click="saveApiKeys">
      更新
    </v-btn>
  </permission-guard>
</template>

<script>
import axios from 'axios'
import PermissionGuard from '@/components/commons/PermissionGuard'
import { deserialize } from 'deserialize-json-api'

export default {
  components: {
    PermissionGuard
  },
  props: {
    siteId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      apiKey: {
        amazonPaAccessKey: null,
        amazonPaSecretKey: null,
        amazonPaAssociateTag: null,
        rakutenWsApplicationId: null,
        rakutenWsAffiliateId: null,
        onamaeMmContractId: null,
        onamaeMmPassword: null
      },
      beforeApiKeyData: {
        maskedAmazonPaAccessKey: null,
        maskedAmazonPaSecretKey: null,
        amazonPaAssociateTag: null,
        maskedRakutenWsApplicationId: null,
        rakutenWsAffiliateId: null,
        maskedOnamaeMmContractId: null,
        maskedOnamaeMmPassword: null
      }
    }
  },
  mounted () {
    this.fetchApiKeys()
  },
  methods: {
    fetchApiKeys () {
      axios.get('/api/api_keys').then(({ data }) => {
        this.beforeApiKeyData = deserialize(data).data
      })
    },
    saveApiKeys () {
      axios.post('/api/api_keys', { apiKey: this.apiKey }).then(
        ({ data }) => {
          const payload = {
            status: 200,
            message: '保存しました'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
          this.beforeApiKeyData = deserialize(data).data
        },
        (error) => {
          const payload = {
            status: error.response.status,
            message: error.response.data.errors
              ? error.response.data.errors.toString()
              : '空白です'
          }
          this.$store.dispatch('SystemMessageStore/createMessage', payload)
        }
      )
    }
  }
}
</script>

<style></style>
